import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs";
import { IDataFilter } from "../commons/types/interfaces/filters.interfaces";
import {
  IBot,
  IBotInactiveDoc,
  IBotListResponse,
} from "../commons/types/interfaces/bots.interface";

@Injectable({
  providedIn: "root",
})
export class ChatbotManagementService {
  constructor(private http: HttpClient) {}

  get(payload: IDataFilter): Observable<any> {
    const url = `${environment.BASE_URL}/chatbot-management?sortOrder=${payload.sortOrder}&page=${payload.page}&pageSize=${payload.pageSize}&sortColumn=${payload.sortColumn}`;
    return this.http.get<IBotListResponse>(url);
  }

  getByName(name: string, filter?: IDataFilter) {
    let param = new HttpParams();
    if (filter?.page) {
      param = param.set("page", filter.page);
    }
    if (filter?.pageSize) {
      param = param.set("pageSize", filter.pageSize);
    }
    param = param.set("sortOrder", "asc");
    param = param.set("sortColumn", "seqNumber");
    const url = `${environment.BASE_URL}/chatbot-management/${name}`;
    console.log(param, filter);
    return this.http.get<IBot>(url, {
      params: param,
    });
  }

  getByNameInactiveDocuments(name: string, filter?: IDataFilter) {
    let param = new HttpParams();
    if (filter?.page) {
      param = param.set("page", filter.page);
    }
    if (filter?.pageSize) {
      param = param.set("pageSize", filter.pageSize);
    }
    param = param.set("sortOrder", "asc");
    param = param.set("sortColumn", "seqNumber");
    const url = `${environment.BASE_URL}/chatbot-management/${name}/get-documents/inactive`;
    console.log(param, filter);
    return this.http.get<IBotInactiveDoc>(url, {
      params: param,
    });
  }

  getPresignedURL(key: string, bucketName: string) {
    const url = `${environment.BASE_URL}/chatbot-management/get-presigned-url?key=${key}&bucketName=${bucketName}`;
    return this.http.get(url);
  }

  deleteDocument(id: string) {
    const url = `${environment.BASE_URL}/chatbot-management/document/${id}`;
    return this.http.delete(url);
  }

  getDocuments(botId: string, isManage = false) {
    const url = `${
      environment.BASE_URL
    }/chatbot-management/${botId}/get-documents${
      isManage ? "?isManage=true" : ""
    }`;
    return this.http.get<IBot>(url);
  }

  addDocumentToBot(botId: string, formData: FormData): Observable<any> {
    const url = `${environment.BASE_URL}/chatbot-management/${botId}/add-document`;
    return this.http.post(url, formData);
  }

  activateAction(id: any, payload: { action: boolean }) {
    const url = `${environment.BASE_URL}/chatbot-management/activate-document/${id}`;
    return this.http.post(url, payload);
  }

  enabledChatbotChange(id: any, enabled: boolean) {
    const url = `${environment.BASE_URL}/chatbot-management/${id}/enabled`;
    return this.http.put(url, {
      enabled,
    });
  }
}
